import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import * as i0 from "@angular/core";
const defaultTranslations = {
    'ngx-shared-due-to-inactivity': 'Due to inactivity,',
    'ngx-shared-minute': 'minute',
    'ngx-shared-minutes': 'minutes',
    'ngx-shared-remaining': 'remaining',
    'ngx-shared-second': 'second',
    'ngx-shared-seconds': 'seconds',
    'ngx-shared-you-have-been-logged-out': 'you have been logged out.',
    'ngx-shared-you-will-be-logged-out-automatically': 'you will be logged out automatically.',
    'ngx-shared-your-session-will-expire-in': 'Your session will expire in',
    'ngx-shared-close-dialog': 'close dialog',
    'ngx-shared-close-this-alert': 'Close this alert',
    'ngx-shared-important': 'Important',
    'ngx-shared-success': 'Success',
    'ngx-shared-warning': 'Warning',
    'ngx-shared-error': 'Error',
    'ngx-shared-menu-option': 'menu option',
    'ngx-shared-options': 'Options',
    'ngx-shared-search': 'Search',
    'ngx-shared-select-all': 'Select all',
    'ngx-shared-selected': 'selected',
    'ngx-shared-content-is-loading': 'Content is loading',
    'ngx-shared-please-wait-the-page-is-loading': 'Please wait, the page is loading.',
    'ngx-shared-of': 'of',
    'ngx-shared-off': 'off',
    'ngx-shared-on': 'on',
    'ngx-shared-switch': 'switch',
    'ngx-shared-instructions-toggle-tip': 'instructions toggle tip button',
    'ngx-shared-open-calendar': 'Open Calendar',
    'ngx-shared-page': 'Page',
    'ngx-shared-showing': 'Showing',
    'ngx-shared-results': 'results',
    'ngx-shared-page-changed': 'Page changed',
    'ngx-shared-to': 'to',
    'ngx-shared-pager-ellipsis': 'horizontal ellipses',
};
export class TranslateAdapter {
    language;
}
export class DefaultTranslateAdapter extends TranslateAdapter {
    language = 'en-us';
    translate(key, context, language) {
        const checkIfKeyExistsinDefaults = Object.keys(defaultTranslations).find((k) => k === key);
        if (!!checkIfKeyExistsinDefaults) {
            return new BehaviorSubject(defaultTranslations[key]);
        }
        return new BehaviorSubject(key);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DefaultTranslateAdapter, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DefaultTranslateAdapter });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DefaultTranslateAdapter, decorators: [{
            type: Injectable
        }] });
export class TranslateService {
    translateAdapter;
    constructor(translateAdapter) {
        this.translateAdapter = translateAdapter;
    }
    get language() {
        return this.translateAdapter.language;
    }
    translate(key, context) {
        try {
            return this.translateAdapter.translate(key, context, this.language);
        }
        catch (err) {
            console.warn(`language: ${this.language}, key: ${key}, args:${JSON.stringify(context)}`);
            console.warn(err);
            return of(undefined);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslateService, deps: [{ token: TranslateAdapter }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslateService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslateService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: TranslateAdapter }]; } });
